<template lang="pug">
div
  UiCardSection
    UiStack
      UiStackItem(fill)
        .ui-card-section-title {{ $t("resellers.tabs.basic") }}

  UiCardSection
    .form-container.mt-5
      UiFormGroup(:label="$t('resellers.name')")
        UiInput#reseller-name-input(v-model="reseller.name")

      UiFormGroup(:label="$t('resellers.business_id')")
        UiInput#business-id-input(v-model="reseller.company_id")

      UiFormGroup(:label="$t('resellers.einvoice_address')")
        UiInput#einvoice-address-input(v-model="reseller.einvoice_address")

      UiFormGroup(:label="$t('resellers.einvoice_operator_address')")
        UiInput#einvoice-operator-address-input(
          v-model="reseller.einvoice_operator_address"
        )

      UiFormGroup(:label="$t('resellers.rtype')")
        UiMultiselect#reseller-type-input(
          v-model="reseller.rtype"
          :options="rtypeOptions"
          :canClear="false"
          :canDeselect="false"
        )

      UiFormGroup
        UiCheckbox#automate-accounting-input(
          v-model="reseller.automate_accounting"
          switch
        ) {{ $t("resellers.automate_accounting") }}

      UiFormGroup
        UiCheckbox#default-dimensions-input(
          v-model="reseller.default_dimensions"
          switch
        ) {{ $t("resellers.default_dimensions") }}

      UiFormGroup(:label="$t('resellers.domain')")
        UiInput#domain-input(v-model="reseller.domain")

      UiFormGroup
        UiStack
          UiStackItem(fill)
          UiStackItem
            UiButton(
              variant="primary"
              @click="save"
            ) {{ $t("actions.save") }}
</template>

<script>
import router from "@/router";
import ApiResellers from "@/api/resellers.js";

export default {
  data() {
    return {
      rtypeOptions: [
        {
          value: "Bookkeeping",
          label: "Bookkeeping",
        },
        {
          value: "Others",
          label: "Others",
        },
      ],
      reseller: {},
    };
  },

  methods: {
    getData() {
      ApiResellers.getReseller(this.$route.params.id).then((resp) => {
        this.reseller = resp.data.reseller;
      });
    },

    save() {
      ApiResellers.updateReseller(this.reseller.id, this.reseller).then(
        (resp) => {
          this.reseller = resp.data.reseller;
        },
      );
    },
    goBack() {
      router.push("/resellers");
    },
  },
  mounted() {
    this.getData();
  },
};
</script>
